module.exports = __webpack_public_path__ + "static/media/slide1.eeb10a30.jpeg";